// extracted by mini-css-extract-plugin
export var preguntasFrecuentesContainer = "PreguntasFrecuentes-module--preguntas-frecuentes-container--pckWR";